export default function DashboardCards({ payments, actionColumns, paymentActions }) {

  const total = payments.length;
  const visibleActions = actionColumns
    .flatMap((column) =>
      column.options.map((option) => ({
        ...option,
        columnId: column.id,
        label: `${column.label}: ${option.label}`
      }))
    )
    .slice(0, 3);
  const legacyActions = visibleActions.length ? [] : paymentActions.slice(0, 3);

  return (
    <div className="cards">

      <div className="card">
        <h3>Всего платежей</h3>
        <h1>{total}</h1>
      </div>

      {visibleActions.map((action) => (
        <div className="card" key={action.id}>
          <h3>{action.label}</h3>
          <h1>
            {payments.filter((p) => p.extra_fields?.[action.columnId] === action.value).length}
          </h1>
        </div>
      ))}

      {legacyActions.map((action) => (
        <div className="card" key={action.id}>
          <h3>{action.label}</h3>
          <h1>{payments.filter((p) => p.status === action.status).length}</h1>
        </div>
      ))}

    </div>
  );
}
